import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, " Pusher Notification ", -1)
const _hoisted_2 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_3 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "float-start" }, "SITE")
], -1)
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row row-cols-2 row-cols-md-6 row-cols-md-8 g-4" }
const _hoisted_8 = { class: "card mb-0 h-100" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "header-title" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "d-flex align-items-center mt-4" }
const _hoisted_13 = { class: "flex-shrink-0" }
const _hoisted_14 = { class: "font-13 text-muted my-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 ms-2" }, null, -1)
const _hoisted_16 = { class: "text-end multi-user" }
const _hoisted_17 = {
  key: 0,
  class: "d-flex justify-content-center mt-4 mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      ($setup.acesso.btnInsert)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: `/newlista/${$setup.route.params.t}/${$setup.route.params.id}/${$setup.route.params.perfil}`,
            class: "btn btn-sm btn-outline-secondary",
            title: "Nova Lista"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "file" })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createTextVNode(" Total Registro: " + _toDisplayString($setup.dados.totalreg), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        class: "form-control",
        placeholder: "Procurar Nome ou Descrição",
        onKeyup: _cache[0] || (_cache[0] = ($event: any) => ($setup.search($event.target.value)))
      }, null, 32)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredTable, (site) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-sm-3 col-xl-3 mb-3",
              key: site.id
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h4", _hoisted_10, _toDisplayString(site.name), 1),
                  ($setup.acesso.btnAlter)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `/sitenotification/${$setup.route.params.t}/${$setup.route.params.id}/${$setup.route.params.perfil}/${site.id}`,
                        class: "text-dark text-decoration-none",
                        title: "Grupos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h1", _hoisted_11, [
                            _createVNode(_component_font_awesome_icon, { icon: "bell" })
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("h5", _hoisted_14, [
                        _createElementVNode("span", {
                          class: _normalizeClass(site.status===1 ? 'badge bg-danger d-block' : 'badge bg-primary d-block')
                        }, _toDisplayString(site.status==1 ? ' Ativo ' : 'Inativo'), 3)
                      ])
                    ]),
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("p", null, _toDisplayString(site.domain), 1)
                    ])
                  ])
                ])
              ])
            ]))
          }), 128))
        ]),
        ($setup.page < $setup.lastPage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.loadMore && $setup.loadMore(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}